import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../pages/Home.vue'
import Login from '../pages/login.vue'
import Dashboard from '../views/Dashboard.vue'
import Publish_Files from '../views/Publish_Files.vue'
import Users from '../views/Users.vue'
import Deposit from '../views/Deposit.vue'
import Account_Type from '../views/Account_Type.vue'
import Traffic from '../views/Traffic.vue'
import Trend from '../views/Trend.vue'
import Channels from '../views/Channels.vue'
import Journey from '../views/Journey.vue'
import Country from '../views/Country.vue'


Vue.use(VueRouter)
export default new VueRouter({
    // mode: 'history',    // 路由模式，该模式不会在地址中显示井号#
    routes: [
       
        {
            path: '/',
            name: 'Home',
            component: Home,
            children: [
                {
                    path: "Dashboard",
                    name: "Dashboard",
                    component: Dashboard,
                    children: [
                        {
                            path: "Users",
                            name: "Users",
                            component: Users
                        },
                        {
                            path: "Deposit",
                            name: "Deposit",
                            component: Deposit
                        },
                        {
                            path: "Account_Type",
                            name: "Account_Type",
                            component: Account_Type
                        },
                        {
                            path: "Traffic",
                            name: "Traffic",
                            component: Traffic,
                            children: [
                                {
                                    path: "Trend",
                                    name: "Trend",
                                    component: Trend
                                },
                                {
                                    path: "Channels",
                                    name: "Channels",
                                    component: Channels
                                },
                                {
                                    path: "Journey",
                                    name: "Journey",
                                    component: Journey
                                },
                                {
                                    path: "Country",
                                    name: "Country",
                                    component: Country
                                },
                                {
                                    path: "/Dashboard/Traffic",
                                    redirect: "/Dashboard/Traffic/Trend"
                                }
                            ],
                        },
                        {
                            path: "/Dashboard",
                            redirect: "/Dashboard/Users"
                        }
                    ],

                },
                {
                    path: "Publish_Files",
                    name: "Publish_Files",
                    component: Publish_Files
                },
                {
                    path: "/",
                    redirect: "/Dashboard"
                }
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js